import { Link } from "react-router-dom";
import { Lock, Play } from "lucide-react";

export function EpisodeCard({ ep, size = "md" }) {
  const tierBadge = ep.tier === "free" ? "Preview" : ep.tier === "silver" ? "Silver" : ep.tier === "platinum" ? "Platinum" : "Gold";
  const sizeClasses = size === "lg" ? "aspect-[4/3]" : "aspect-[3/2]";
  return (
    <Link to={`/episodes/${ep.id}`} data-testid={`episode-card-${ep.id}`} className="group block media-card">
      <div className={`relative ${sizeClasses} overflow-hidden`} style={{ background: "var(--surface)" }}>
        <img src={ep.cover_image} alt={ep.title} className="w-full h-full object-cover" loading="lazy" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(9,10,12,0.85) 0%, rgba(9,10,12,0.1) 50%, transparent 100%)" }} />
        <div className="absolute top-4 left-4 flex items-center gap-2 px-3 py-1" style={{ background: "rgba(9,10,12,0.7)", border: "1px solid var(--hairline-strong)" }}>
          {ep.tier !== "free" && <Lock size={10} style={{ color: "var(--brass)" }} />}
          <span className="text-[0.625rem] uppercase tracking-[0.22em]" style={{ color: ep.tier === "free" ? "var(--ink)" : "var(--brass)" }}>
            {tierBadge}
          </span>
        </div>
        <div className="absolute bottom-4 right-4 w-12 h-12 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: "rgba(9,10,12,0.8)", border: "1px solid var(--brass)" }}>
          <Play size={16} style={{ color: "var(--brass)" }} fill="currentColor" />
        </div>
      </div>
      <div className="pt-4">
        <p className="eyebrow mb-2">{ep.industry} · {ep.runtime}</p>
        <h3 className="font-display text-2xl leading-tight mb-2 group-hover:text-[var(--brass)] transition-colors duration-300">
          {ep.title}
        </h3>
        <p className="text-sm" style={{ color: "var(--ink-muted)" }}>
          With <span style={{ color: "var(--ink)" }}>{ep.guest_name}</span>, {ep.guest_title}
        </p>
      </div>
    </Link>
  );
}

export function ArticleCard({ article }) {
  return (
    <Link to={`/articles/${article.id}`} data-testid={`article-card-${article.id}`} className="group block media-card">
      <div className="relative aspect-[5/4] overflow-hidden" style={{ background: "var(--surface)" }}>
        <img src={article.cover_image} alt={article.title} className="w-full h-full object-cover" loading="lazy" />
      </div>
      <div className="pt-5">
        <p className="eyebrow mb-2">{article.category} · {article.author}</p>
        <h3 className="font-display text-3xl leading-[1.05] mb-3 group-hover:text-[var(--brass)] transition-colors duration-300">
          {article.title}
        </h3>
        <p className="text-sm leading-relaxed" style={{ color: "var(--ink-muted)" }}>
          {article.excerpt}
        </p>
      </div>
    </Link>
  );
}

export function MemberCard({ member }) {
  return (
    <Link to={`/directory/${member.id}`} data-testid={`member-card-${member.id}`} className="group block media-card" style={{ border: "1px solid var(--hairline)" }}>
      <div className="aspect-[4/5] overflow-hidden" style={{ background: "var(--surface)" }}>
        <img src={member.portrait} alt={member.name} className="w-full h-full object-cover" loading="lazy" />
      </div>
      <div className="p-5">
        <p className="eyebrow mb-2">{member.tier}</p>
        <h3 className="font-display text-2xl leading-tight mb-1 group-hover:text-[var(--brass)] transition-colors duration-300">
          {member.name}
        </h3>
        <p className="text-sm" style={{ color: "var(--ink-muted)" }}>
          {member.title}, {member.company}
        </p>
        <p className="text-xs mt-2 uppercase tracking-[0.18em]" style={{ color: "var(--ink-faint)" }}>
          {member.industry} {member.location && `· ${member.location}`}
        </p>
      </div>
    </Link>
  );
}
